<template>
  <div class="video-img" @click="handleImgClick">
    <div
      v-show="isLoading"
      class="absolute left-0 top-0 w-full h-full flex items-center justify-center bg-black"
    >
      <Loading class="z-10" />
    </div>

    <div class="video-img-wrap absolute w-full h-full flex items-center justify-center">
      <transition name="fade">
        <img
          v-show="!isError && !isLoading"
          ref="imgContainer"
          :key="content.url"
          class="max-w-full max-h-full"
          :src="content.url"
          alt=""
          @error="handleError"
          @load="handleLoaded"
        />
      </transition>
    </div>
    <transition name="fade">
      <div
        v-show="isError"
        class="error-wrap w-full h-full flex flex-col items-center justify-center"
      >
        <img src="./asstes/error.svg" alt="" />
        <div class="error-tips">
          很抱歉，图片加载失败
        </div>
        <div class="error-reload-btn error-btn" @click="handleImgReload">重新加载</div>
        <div class="error-next-btn error-btn" @click="handleNextBtnClick">跳过</div>
      </div>
    </transition>

    <NextBtn :isShow="isNextBtnShow" @nextbtn-click="handleNextBtnClick" />
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import Loading from '@/components/common/system-loading';
import NextBtn from '@/components/resources/interactive-video/components/NextBtn.vue';

@Component({
  components: {
    NextBtn,
    Loading
  }
})
export default class VideoImg extends Vue {
  @Prop({ type: Object }) content!: Content & {
    url: string;
    delay?: number;
  };
  @Prop() isInLookBack!: boolean;

  isError = false;
  loaded = false;
  isNextBtnShow = false;
  loadingTimer: number | null = null;

  @Watch('content')
  handleContentChange() {
    this.isError = false;
    this.loaded = false;
    this.isNextBtnShow = false;
    this.startLoadingTimer();
    this.$emit('changeTitleVisible');
  }

  get isLoading() {
    return !this.isError && !this.loaded;
  }

  startLoadingTimer() {
    this.loadingTimer = window.setTimeout(() => {
      this.isNextBtnShow = true;
    }, 1000);
  }

  clearLoadingTimer() {
    if (this.loadingTimer) {
      window.clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }
  }

  handleLoaded() {
    this.clearLoadingTimer();
    this.loaded = true;
    this.handleBtnShow();
  }

  handleBtnShow() {
    let delayTime = this.content.delay || 1000;
    if (this.isInLookBack) {
      delayTime = 0;
    }

    setTimeout(() => {
      this.isNextBtnShow = true;
    }, delayTime);
  }

  handleError() {
    this.clearLoadingTimer();
    this.isError = true;
    this.$emit('changeTitleVisible', true);
  }

  handleImgClick() {
    if (this.isError) return;
    this.$emit('toggleTitleShow');
  }

  handleNextBtnClick() {
    this.$emit('next');
  }

  getNewUrl() {
    let url = this.content.url;
    const t = new Date().getTime();
    if (url.includes('?')) {
      url += `&vi=${t}`;
    } else {
      url += `?vi=${t}`;
    }
    return url;
  }

  handleImgReload() {
    this.isError = false;
    setTimeout(() => {
      const img = this.$refs.imgContainer as HTMLImageElement;
      if (img) {
        console.log();
        img.src = this.getNewUrl();
      }
    }, 600);
  }

  beforeDestroy() {
    this.clearLoadingTimer();
  }
}
</script>

<style lang="scss" scoped>
.video-img {
  @apply absolute w-full h-full left-0 top-0 flex justify-center items-center overflow-hidden bg-black;
  z-index: 2;

  .error-wrap {
    position: relative;
    color: #fff;
    background: #34363d;
    img {
      width: 104px;
      margin-bottom: 15px;
    }

    .error-tips {
      position: relative;
      margin-bottom: 28px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      line-height: 21px;
    }
    .error-btn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 240px;
      height: 43px;
      line-height: 20px;
      border-radius: 8px;
      cursor: pointer;
      &:hover,
      &:active {
        opacity: 0.85;
        transition: opacity 0.2s;
      }
    }

    .error-reload-btn {
      margin-bottom: 15px;
      background: linear-gradient(95.22deg, #524eff 6.46%, #8b8eff 91.58%);
    }
    .error-next-btn {
      border: 1px solid rgba(255, 255, 255, 0.6);
    }
  }

  .error-tips {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    line-height: 21px;
    text-align: center;
  }

  @keyframes breath {
    from {
      transform: scale(0.9);
    }
    50% {
      transform: scale(1);
    }
    to {
      transform: scale(0.9);
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease-in-out;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
